import type { StreamProvider } from '@vgtv/api-client';

export type Theme = 'vg' | 'ab' | 'e24' | 'ap' | 'bt' | 'sa' | 'svd' | 'tek';

const themes: Theme[] = ['vg', 'ab', 'e24', 'ap', 'bt', 'sa', 'svd', 'tek'];

export const isHandledTheme = (dnaStyle: string): dnaStyle is Theme => {
  return themes.includes(dnaStyle as Theme);
};

export const vendorToDnaStyle: Partial<Record<StreamProvider, Theme>> = {
  vgtv: 'vg',
  vgtvexternal: 'vg',
  ab: 'ab',
  e24: 'e24',
  ap: 'ap',
  bt: 'bt',
  sa: 'sa',
  svd: 'svd',
  vgtts: 'vg',
  abtts: 'ab',
  aptts: 'ap',
  bttts: 'bt',
  satts: 'sa',
};

export const resolveDnaStyleOption = (
  vendor: StreamProvider,
  dnaStyle?: string
): Theme => {
  if (dnaStyle && isHandledTheme(dnaStyle)) {
    return dnaStyle;
  }

  return vendorToDnaStyle[vendor] ?? 'vg';
};
